import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartItem {
  id: string | number;
  price: number;
}

interface CartState {
  cartItems: CartItem[];
  totalPrice: number;
}

const initialState: CartState = {
  cartItems: [],
  totalPrice: 0,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<any>) => {
      const { id, price } = action.payload;
      const cartItems = state.cartItems;
      const index = cartItems.findIndex((item) => item.id === id);
      if (index === -1) {
        cartItems.push({ id, price });
        state.cartItems = cartItems;
        state.totalPrice += price;
      } else {
        cartItems[index].price += price;
        state.cartItems = cartItems;
        state.totalPrice += price;
      }
    },
    removeFromCart: (state, action: PayloadAction<any>) => {
      const { id } = action.payload;
      const cartItems = state.cartItems;
      const index = cartItems.findIndex((item) => item.id === id);
      if (index !== -1) {
        const price = cartItems[index].price;
        cartItems.splice(index, 1);
        state.cartItems = cartItems;
        state.totalPrice -= price;
      }
    },
    clearCart: (state) => {
      state.cartItems = [];
      state.totalPrice = 0;
    },
  },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;